import React from "react";
import s from "./TeamMember.module.scss";
import { DownloadOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

// Display-only: "Mr. IGBAL BABAYEV" -> "Mr. Igbal Babayev"
const formatName = (name) =>
  name
    .trim()
    .split(/\s+/)
    .map((w) => (w.endsWith(".") ? w : w.charAt(0) + w.slice(1).toLowerCase()))
    .join(" ");

const TeamMember = ({ member }) => {
  const openFileInNewWindow = (e, file) => {
    e.preventDefault();
    const fileUrl = file;
    window.open(fileUrl, "_blank");
  };

  return (
    <div className={s.member}>
      <div className={s.media}>
        <div className={s.img_wrapper}>
          <img src={member.img} className={s.img} />
        </div>
        {member.position && <div className={s.badge}>{member.position}</div>}
      </div>
      <div className={s.member_desc}>
        <div className={s.name}>{formatName(member.name)}</div>
        <div className={s.country}>
          <div className={s.country_name}>
            <img
              src={member.flag}
              className={
                member.name === "Mr. IGBAL BABAYEV" ? s.logo_name : s.flag
              }
            />{" "}
            {member.country}
          </div>
          {/* {member.cv ? (
            <div
              className={s.cv}
              onClick={(e) => openFileInNewWindow(e, member.cv)}
            >
              <DownloadOutlined className={s.icon} /> CV
            </div>
          ) : null} */}
        </div>
        <div
          className={
            member.name === "Mr. IGBAL BABAYEV"
              ? s.head_description
              : s.description
          }
        >
          {member.description}
        </div>

        {member.name && (
          <div
            onClick={(e) => openFileInNewWindow(e, member.cv)}
            className={s.more}
          >
            More details
            <span className={s.more_icon}>
              <ArrowRightOutlined />
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default TeamMember;
